/**
 * ALDER SEARCH — Home Page
 * Design: "Alder Forest — Organic Precision"
 * Lean signpost homepage: hero → practice selector → sectors → testimonial → team → insights → contact
 */

import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import PracticeSelectorSection from "@/components/PracticeSelectorSection";
import SectorsSection from "@/components/SectorsSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import TeamSection from "@/components/TeamSection";
import InsightsSection from "@/components/InsightsSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navigation />
      <HeroSection />
      <PracticeSelectorSection />
      <SectorsSection />
      <TestimonialsSection />
      <TeamSection />
      <InsightsSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
